import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  modalContentText: {
    flexGrow: 1,
    fontSize: '14px',
    fontWeight: 300,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.29,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#464646',
  },
  subHeader: {
    fontSize: '6',
    fontWeight: '600',
    color: '#74808b',
    lineHeight: '1.5',
    marginTop: '8px',
  },
  listItem: {
    fontSize: '14px',
    fontWeight: '300',
    color: '#74808b',
    lineHeight: 1.5,
    paddingLeft: 0,
    paddingTop: '2px',
  },
}));
